<template>
  <div>
    <div
      class="size-full will-change-transform"
      :style="`transform: translateX(${smoothTilt * multiplier}px) translateY(${-smoothRoll * multiplier}px);`"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  tilt: { type: Number, default: 0 },
  roll: { type: Number, default: 0 },
  multiplier: { type: Number, default: 45 },
  fraction: { type: Number, default: 0.025 },
})

const smoothTilt = ref(0)
const smoothRoll = ref(0)

// We need to lerp the values to make the movement smooth
// css transitions debounce before it animates
watch(
  () => [props.tilt, props.roll],
  (newValues) => {
    smoothTilt.value = lerp(smoothTilt.value, newValues[0], props.fraction)
    smoothRoll.value = lerp(smoothRoll.value, newValues[1], props.fraction)
  }
)

// Linear interpolation
function lerp(start, end, fraction) {
  return start + (end - start) * fraction
}
</script>
